import React from "react"

const CampaignInfo = () => {
  return (
    <div className="iphone_campaign" id="campaign">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1 col-md-12 mb-2">
            <div className="title text-center">
              SOMPO TravelSafe - Travel 2Gether Campaign
            </div>
            <div className="sub-title">
              <div className="sub-title mt-3">
                Good news to all travellers! With Sompo Travel 2Gether campaign, you can get up to RM60 TNG eWallet when you buy SOMPO TravelSafe group travel insurance from 15 Apr – 15 Jun 2024. 
              </div>
              <div className="sub-title mt-3">
                Whether you are celebrating love, friendship, or simply the joy of exploration, there is no better way than travel together. Let’s take the lead and buy group travel insurance on behalf of your friends and family to ensure your travel buddies stay protected and embark on an unforgettable journey with peace of mind. 
              </div>
            </div>
            <div className="sub-title mt-3">
              To participate:
            </div>
            <div className="sub-title price_iphone row">
              <ul className="mt-3">
                <li>
                  <span className="bold"> 1: </span> Buy SOMPO TravelSafe group travel insurance (with more than 1 adult/child) online with minimum premium above RM200. 
                </li>
                <li>
                  <span className="bold"> 2: </span> Upon successful purchase, you will be automatically enrolled in this campaign 
                </li>
              </ul>
            </div>
            <table
              className="table-raya mt-3 mb-3"
              width="100%"
              border="0"
              align="center"
              cellPadding="0"
              cellSpacing="0"
            >
              <tr>
                <th align="left" valign="top">
                  <strong>Policy Type</strong>
                </th>
                <th align="center" valign="top">
                  <strong>Payable Premium</strong>
                </th>
                <th align="center" valign="top">
                  <strong>
                  Total Reward
                  <br /> (TNG e-voucher)
                  </strong>
                </th>
              </tr>
              <tr>
                <td align="center" valign="top center" rowspan="3">
                 Group (With more than 1 adult/child)
                </td>
                <td align="center" valign="top">
                  Above RM200 - RM400
                </td>
                <td align="center" valign="top">
                  RM 20
                </td>
              </tr>
              <tr>
                <td align="center" valign="top">
                  Above RM400 – RM600
                </td>
                <td align="center" valign="top">
                  RM 40
                </td>
              </tr>

              <tr>
                <td align="center" valign="top">
                  Above RM600
                </td>
                <td align="center" valign="top">
                  RM 60
                </td>
              </tr>
            </table>
            {/* <br /> */}
            {/* <div className="sub-title mt-3">
              Note: GrabGifts e-vouchers will be fulfilled via email within 45
              days after the campaign ends if you meet the eligibility
              requirements.
            </div> */}
            <div className="sub-title mt-3">Sample illustration as below:</div>
            <table
              className="table-raya mt-3 mb-3"
              width="100%"
              border="0"
              align="center"
              cellPadding="0"
              cellSpacing="0"
            >
              <tr>
                <th align="center" valign="top">
                  <strong>Customer</strong>
                </th>
                <th align="center" valign="top">
                  <strong>Adult/Child</strong>
                </th>
                <th align="center" valign="top">
                  <strong>Payable Premium</strong>
                </th>
                <th align="center" valign="top">
                  <strong>Total Reward</strong>
                </th>
              </tr>
              <tr>
                <td align="center" valign="top">
                Customer A
                </td>
                <td align="center" valign="top">
                1 Adult
                </td>
                <td align="center" valign="top">
                RM230
                </td>
                <td align="center" valign="top">
                RM0
                </td>
              </tr>
              <tr>
                <td align="center" valign="top">
                Customer B
                </td>
                <td align="center" valign="top">
                2 Adults
                </td>
                <td align="center" valign="top">
                RM120
                </td>
                <td align="center" valign="top">
                RM0
                </td>
              </tr>
              <tr>
                <td align="center" valign="top">
                Customer C
                </td>
                <td align="center" valign="top">
                1 Adult + 1 Child
                </td>
                <td align="center" valign="top">
                RM280
                </td>
                <td align="center" valign="top">
                RM20
                </td>
              </tr>
              <tr>
                <td align="center" valign="top">
                Customer D
                </td>
                <td align="center" valign="top">
                3 Adults
                </td>
                <td align="center" valign="top">
                RM470
                </td>
                <td align="center" valign="top">
                RM40
                </td>
              </tr>
              <tr>
                <td align="center" valign="top">
                Customer E
                </td>
                <td align="center" valign="top">
                6 Adults
                </td>
                <td align="center" valign="top">
                RM630
                </td>
                <td align="center" valign="top">
                RM60
                </td>
              </tr>
            </table>
            <br />
            <div className="sub-title mt-3">Terms & Conditions apply.</div>
            <div className="sub-title mt-3">Note: TNG e-voucher will be fulfilled via email within 45 days after the campaign is ended.</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 mt-4 offset-md-4 text-center">
            <a
              target="_blank"
              href="https://online.berjayasompo.com.my/securetravel/docs/SOMPO Travel 2Gether Campaign. TCs (Final).pdf"
              rel="noreferrer"
            >
              <div className="btn btn-red ghost">
                <div className="back"> Terms and conditions </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CampaignInfo
